// extracted by mini-css-extract-plugin
export default {"Flash":"RecentlyTouchedBranches-module__Flash--ZwF1d","Box":"RecentlyTouchedBranches-module__Box--YQ8UP","Octicon":"RecentlyTouchedBranches-module__Octicon--Gt0Jx"};